import InvoicePos from './InvoicePos';

export default InvoicePos;
